import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { CustomAccordion, Text } from "../../shared/uiComponents";
import { Loader, InfoRow as Row } from "../StyledComponents";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getClinicalSupervisorsBCBAs } from "../../redux/State/userSlice";

const BCBAList = ({ userId }: { userId: string }) => {
  const dispatch = useDispatch<DispatchProperties>();

  const bcbas = useSelector((state) => state.user.clinicalSupervisorsBcbas);
  const loading = useSelector((state) => state.user.loadingClinicalSupervisor);

  useEffect(() => {
    if (!userId) return;
    dispatch(getClinicalSupervisorsBCBAs(userId));
  }, [dispatch, userId]);

  return (
    <CustomAccordion
      headerStyle={{ padding: 0 }}
      HeaderContent={() => (
        <Row>
          <Text title={"BCBAs Assigned: "} size={"smallBold"} />
          <Text title={`${!!bcbas?.length ? bcbas.length : 0}`} />
        </Row>
      )}
      Content={() => (
        <>
          {!!bcbas?.length ? (
            <>
              {bcbas.map((user, index) => (
                <Text key={index} title={`${index + 1}. ${user.fullName}`} />
              ))}
            </>
          ) : (
            <Text title={"None"} />
          )}
          {loading && <Loader />}
        </>
      )}
    />
  );
};

export default BCBAList;
